export default __webpack_public_path__ + "static/Banner_thewrap_mobile-5908ea03a50422df7bdf099274dbc9bc.mp4";